import { all } from 'redux-saga/effects'

export function* billingSaga() {
  yield all([])
}
